enum FormType {
  MakesModels = 'makes_models',
  Models = 'models'
}

export default FormType;
